import React from "react";

import loadingImg from '../_img/loader.gif';

const style = {
  alignItems: "center",
  background: "#fff",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  left: "0",
  position: "fixed",
  top: "0",
  transition: "opacity 0.3s linear",
  width: "100%",
  zIndex: "9999",
  opacity: "1",
};

function PreLoader({ loading, children, ...props }) {
  const didMountRef = React.useRef(false);
  const [isLoading, setIsLoading] = React.useState(loading);

  React.useEffect(() => {
    let timeout;

    if (didMountRef.current) {
      timeout = setTimeout(() => {
        setIsLoading((isLoading) => !isLoading);
      }, 2000);
    } else {
      didMountRef.current = true;
    }

    return () => clearTimeout(timeout);
  }, [loading, setIsLoading]);

  return (
    <>
      {isLoading && (
        <div style={{ ...style, ...props.style }}>
          <img src={loadingImg} alt="loading..." />
        </div>
      )}
      {children}
    </>
  );
}

PreLoader.defaultProps = {
  loading: false,
};

export default PreLoader;
